import { Component, Input, Output, OnChanges, EventEmitter, OnInit, HostListener } from '@angular/core';
import { Inject, LOCALE_ID } from "@angular/core";
import { UntypedFormGroup, NgForm, ControlContainer, UntypedFormBuilder } from '@angular/forms';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input';

@Component({
    selector: 'tcm-phone',
    templateUrl: './tcm-phone.component.html',
    styleUrls: ['./tcm-phone.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class TcmPhoneComponent implements OnInit, OnChanges {
  @Input() required: boolean;
  @Input() label: string;
  @Input() TelePhone: any;
  @Input() country1: string;
  @Input() isReadonlyValue: boolean;
  @Input() custom: any;
  @Input() allowOnChanges: boolean = false;
  @Output() phoneChange = new EventEmitter<object>();
  @Output() submit = new EventEmitter();
  @Output() clear = new EventEmitter();
  Phone: string;
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  // TooltipLabel = TooltipLabel; ANGULAR CHANGES, THIS CAUSED A PROBLEM IN HTML
  CountryISO = CountryISO;
  selectedCountry: any;
  preferredCountries: CountryISO[];
  ValidationText: any;
  countryCode: any;
  selectedPhoneNumber: any;
  Isvalid: boolean;
  register: UntypedFormGroup;
  Isphonevalid: any;
  Phonehome = "";
  Phonemobile = "";
  Phonework = "";
  Fax = "";
  Isvisible: boolean = false;
  Model: any;


  constructor(@Inject(LOCALE_ID) private locale: string, private fb: UntypedFormBuilder) { }

  private initForm(): void {
    this.register = this.fb.group({
      phone: ['', []],
      phoned: ['', []]
    });
    this.register.controls['phoned'].disable();
  }

  get GetSelectedCountry() {
    if (this.country1 != "" && this.country1 != null && this.TelePhone == null) {
      if (this.country1 == "UK")
        this.country1 = "gb";
      this.selectedCountry = this.country1;
    }

    if (this.TelePhone == null && this.country1 == null) {
      this.setlocale();
    }

    return this.selectedCountry;
  }

  ngOnInit() {
    this.initForm();
    this.formatForm();
  }

  ngOnChanges() {
    if (this.allowOnChanges) {
      if (this.TelePhone != null) {
        if (this.TelePhone.indexOf('+') === -1 && this.country1 != null) {
          this.selectedCountry = this.country1;
        }
        const phoneNumber: any = parsePhoneNumberFromString(this.TelePhone, this.selectedCountry);
        if (phoneNumber) {
          const numformatted = phoneNumber.formatInternational();
          this.register.controls['phone'].setValue(numformatted);
          this.register.controls['phoned'].setValue(numformatted);
          var model = this.register.controls['phoned'].value;
          this.Isvalid = undefined;
          this.phoneChange.emit({ Model: model, Valid: this.Isvalid });
        }
      } else {
        this.register.controls['phone'].setValue(null);
        this.register.controls['phoned'].setValue(null);
      }
    }
  }

  formatPhoneNumber(event: any): void {
    this.selectedPhoneNumber = null;
    let inputValue: any = this.register.controls['phone'].value;
    if (inputValue != null) {
      if (typeof inputValue == 'object' && inputValue != null) {
        if (inputValue["internationalNumber"].length > 1) {
          var phnum = inputValue["internationalNumber"];
          this.countryCode = inputValue["countryCode"];
          let phoneNumber: any = parsePhoneNumberFromString(phnum, this.countryCode);
          this.PhoneNumberValidator(phnum, this.countryCode);

          if (phoneNumber) {
            this.selectedPhoneNumber = phoneNumber.number;
          }
          this.Model = this.register.controls['phone'].value;

          this.phoneChange.emit({ Model: this.Model, Valid: this.Isvalid });
        }
        else {
          this.ValidationText = " ";
          this.Isvisible = false;
          this.Isvalid = true;

          this.phoneChange.emit({ Model: null, Valid: this.Isvalid });
        }
      }
    }
    else {
      this.Isvisible = false;
      this.Isvalid = true;
      this.ValidationText = "";

      this.phoneChange.emit({ Model: null, Valid: this.Isvalid });
    }
  }

  OninitformatPhoneNumber(event: any): void {
    if (this.TelePhone != null) {
      if (this.TelePhone.indexOf("+") == -1 && this.country1 == null) {
        this.setlocale();
      }
      if (this.TelePhone.indexOf("+") == -1 && this.country1 != null) {
        this.selectedCountry = this.country1;
      }

      let phoneNumber: any = parsePhoneNumberFromString(this.TelePhone, this.selectedCountry);
      if (phoneNumber) {
        this.selectedPhoneNumber = phoneNumber.number;
        this.selectedCountry = phoneNumber.country;
        var numformatted = phoneNumber.formatInternational();
        this.register.controls['phone'].setValue(numformatted);
        this.register.controls['phoned'].setValue(numformatted);

        var Model = this.register.controls['phone'].value;
        this.Isvalid = undefined;
        this.phoneChange.emit({ Model: Model, Valid: this.Isvalid });
      }
    }
  }

  PhoneNumberValidator(phnum, regionCode: string = undefined) {
    let validNumber = false;
    try {
      const phoneNumber = parsePhoneNumberFromString(phnum, regionCode as any);
      validNumber = phoneNumber ? phoneNumber.isValid() : false;

      if (validNumber) {
        this.ValidationText = "";
        this.Isvalid = true;
        this.Isvisible = false;
      }
      else {
        this.Isvisible = true;
        this.Isvalid = false;
        this.ValidationText = 'Value must match required pattern';
      }
    } catch (e) { }
  }

  get setpreferred() {
    if (this.locale == "en-US") {
      this.preferredCountries = [CountryISO.UnitedStates, CountryISO.Canada];
    }
    if (this.locale == "en-CA" || this.locale == "fr-CA") {
      this.preferredCountries = [CountryISO.Canada, CountryISO.UnitedStates];
    }
    if (this.locale == "en-GB") {
      this.preferredCountries = [CountryISO.UnitedKingdom];
    }
    if (this.locale == "de-AT") {
      this.preferredCountries = [CountryISO.Austria];
    }

    return this.preferredCountries;
  }

  setlocale() {
    if (this.locale == "en-US") {
      this.selectedCountry = CountryISO.UnitedStates.toUpperCase();
    }
    if (this.locale == "en-CA" || this.locale == "fr-CA") {
      this.selectedCountry = CountryISO.Canada.toUpperCase();
    }
    if (this.locale == "en-GB") {
      this.selectedCountry = CountryISO.UnitedKingdom.toUpperCase();
    }
    if (this.locale == "de-AT") {
      this.selectedCountry = CountryISO.Austria.toUpperCase();
    }
    // France
    // Netherlands
    // Hong Kong
    // New Zealand
    // Australia
  }

  onPhoneChanged(address1Line1: any) {
    if (this.country1 != null && this.TelePhone == null) {
      if (this.country1 == "UK")
        this.country1 = "gb";
      this.selectedCountry = this.country1;
    }

    if (typeof address1Line1 == 'object' && address1Line1 !== null) {
      this.formatPhoneNumber(address1Line1);
    }
  }

  ValidatePhoneForSave(searchObj: any, type: any) {
    this.Isphonevalid = searchObj["Valid"];

    if (type == "homePhone") {
      if (searchObj["Valid"] == false)
        this.Phonehome = "error";
      else
        this.Phonehome = "";
    }
    if (type == "mobilePhone") {
      if (searchObj["Valid"] == false)
        this.Phonemobile = "error";
      else
        this.Phonemobile = "";
    }
    if (type == "workPhone") {
      if (searchObj["Valid"] == false)
        this.Phonework = "error";
      else
        this.Phonework = "";
    }
    if (type == "Fax") {
      if (searchObj["Valid"] == false)
        this.Fax = "error";
      else
        this.Fax = "";
    }
    if (this.Phonehome == "error" || this.Phonework == "error" || this.Phonemobile == "error" || this.Fax == "error") {
      this.Isphonevalid = false;
    }
    else
      this.Isphonevalid = true;

    return this.Isphonevalid;
  }

  isvalid() {
    this.ValidationText = "Please enter a required value";
    this.Isvisible = true;
  }

  onCountryChange(event: any): void {
    this.countryCode = event["iso2"].toUpperCase();
    this.selectedCountry = event["iso2"].toUpperCase();
    this.register.controls['phone'].setValue(null);
    this.formatPhoneNumber(event);
  }

  onClear() {
    this.register.controls['phone'].setValue(null);
    this.ValidationText = "";
    this.Isvalid = true;
    this.Isvisible = false;
    this.selectedCountry = this.preferredCountries;
  }

  formatForm() {
    this.OninitformatPhoneNumber(this.TelePhone);
    if (this.isReadonlyValue) {
      this.register.controls['phoned'].disable();
    }
  }

  sendChanges() {
    this.selectedPhoneNumber = null;
    let inputValue: any = this.register.controls['phone'].value;
    if (inputValue != null) {
      if (typeof inputValue == 'object' && inputValue != null) {
        if (inputValue["internationalNumber"].length > 1) {
          var phnum = inputValue["internationalNumber"];
          this.countryCode = inputValue["countryCode"];
          let phoneNumber: any = parsePhoneNumberFromString(phnum, this.countryCode);
          this.PhoneNumberValidator(phnum, this.countryCode);

          if (phoneNumber) {
            this.selectedPhoneNumber = phoneNumber.number;
            this.register.controls['phone'].setValue(phoneNumber.formatInternational());
          }
          this.Model = this.register.controls['phone'].value;

          this.phoneChange.emit({ Model: this.Model, Valid: this.Isvalid });
        }
        else {
          this.ValidationText = " ";
          this.Isvisible = false;
          this.Isvalid = true;

          this.phoneChange.emit({ Model: null, Valid: this.Isvalid });
        }
      }
    }
    else {
      this.Isvisible = false;
      this.Isvalid = true;
      this.ValidationText = "";

      this.phoneChange.emit({ Model: null, Valid: this.Isvalid });
    }
  }

  changeFormat(number) {
    this.register.controls['phone'].setValue(number);
  }
}
